import {
  SettingsBody,
  SettingsPage,
  SettingsPageHeader,
  SettingsPageHeaderLink,
} from 'src/components/MainSettings/shared/Layout';

export default function BrandSettingsLayout({ children }) {
  return (
    <SettingsPage>
      <SettingsPageHeader>
        <SettingsPageHeaderLink pageKey="edit">Preferences</SettingsPageHeaderLink>
        <SettingsPageHeaderLink pageKey="users">Users</SettingsPageHeaderLink>
        <SettingsPageHeaderLink pageKey="tracking">Tracking Tags</SettingsPageHeaderLink>
        <SettingsPageHeaderLink pageKey="first-party">First Party Data</SettingsPageHeaderLink>
      </SettingsPageHeader>
      <SettingsBody>{children}</SettingsBody>
    </SettingsPage>
  );
}
